import { createBrowserRouter } from "react-router-dom";
import routes from "./routes";
import ConditionalRoute from "@/components/ConditionalRoute/ConditionalRoute";
import RootRedirect from "@/components/RootRedirect/RootRedirect";
import PreLogin from "@/layouts/PreLogin/PreLogin";
import PostLogin from "@/layouts/PostLogin/PostLogin";
import PageNotFound from "@/pages/PageNotFound/PageNotFound";
import RouteErrorFallback from "@/components/RouteErrorFallback/RouteErrorFallback";

// Only routes with a real `element` get mounted — a path-only placeholder
// (e.g. RESET_PASSWORD before ForgotPassword exists) stays a navigation
// target (routes.publicRoutes.RESET_PASSWORD.path) without being routed to
// nothing. See docs/architecture.md's "Routing: what's real right now".
const publicRoutesWithElements = Object.values(routes.publicRoutes).filter(
  (route) => route.element,
);
const privateRoutesWithElements = Object.values(routes.privateRoutes).filter(
  (route) => route.element,
);

const router = createBrowserRouter([
  {
    // Exactly one route matches bare "/" — see RootRedirect for why that
    // matters (a second, competing match used to send a logged-out user
    // to `/dashboard` instead of `/login`).
    path: "/",
    errorElement: <RouteErrorFallback />,
    element: <RootRedirect />,
  },

  // Pathless layout routes (no `path` key) — PreLogin/PostLogin wrap their
  // children without adding a path segment. Neither has an `index` child
  // of its own; the root redirect above is the only route matching "/".
  {
    errorElement: <RouteErrorFallback />,
    element: <ConditionalRoute component={PreLogin} />,
    children: publicRoutesWithElements.map((route) => ({
      path: route.path,
      errorElement: <RouteErrorFallback />,
      element: route.element,
    })),
  },

  {
    errorElement: <RouteErrorFallback />,
    element: <ConditionalRoute isPrivate component={PostLogin} />,
    children: privateRoutesWithElements.map((route) => ({
      path: route.path,
      errorElement: <RouteErrorFallback />,
      element: route.element,
    })),
  },

  {
    path: "*",
    errorElement: <RouteErrorFallback />,
    element: <PageNotFound />,
  },
]);

export default router;
